<mat-toolbar class="fuse-navy h-48">

    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.gt-xs="space-between center" fxFlex>

        <div class="font-size-12" fxLayout="row" fxLayoutAlign="start center" fxHide fxShow.gt-xs>
            SIRCC II
            <span class="mx-8">&bull;</span>
            <a mat-button class="p-0 font-size-12" href="https://byasystems.com.co" target="_blank">B&A Systems 2022 </a> <span class="mx-8">&copy;</span> Todos los derechos reservados
        </div>

    </div>

</mat-toolbar>